import type {
  SiteAutodiagDeviceDiagnosticResult,
  SiteAutodiagDeviceInfo,
  SiteAutodiagDeviceProgrammingConformState,
  SiteAutodiagDeviceProgrammingMode,
  SiteAutodiagDeviceProgrammingType,
} from "~domain/sites/models/site-autodiag-model.ts";
import type { SITE_AUTODIAG_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-autodiag-table/site-autodiag-table.fr.ts";

const test: Record<SiteAutodiagDeviceDiagnosticResult, string> = {
  OK: "Pilotage OK",
  NOK_NO_POWER: "Appliance: No power",
  NOK_NO_MODULATION: "Appliance: No modulation",
  NOK_UNREACHABLE: "Modulator: Connexion failure",
  NOK_DEVICE_UNKNOWN: "Modulator: Connexion failure",
  FAILED_BACKEND: "Failure Voltalis Infra",
};

const energyManager: Record<NonNullable<SiteAutodiagDeviceInfo["hasEnergyManager"]>, string> = {
  HAS_ENERGY_MANAGER: "Detected",
  NO_ENERGY_MANAGER: "Not Detected",
  ERROR_INFRA_VOLTALIS: "Failure Voltalis Infra",
};

const conformity: Record<SiteAutodiagDeviceProgrammingConformState, string> = {
  NOT_CONFORM: "Not conform",
  CONFORM: "Conform",
  FAILED: "Failure Voltalis Infra",
};

const myvMode: Record<SiteAutodiagDeviceProgrammingMode, string> = {
  NORMAL: "Normal",
  CONFORT: "Comfort",
  CONFORTMINUS1: "Comfort -1",
  CONFORTMINUS2: "Comfort -2",
  ECO: "Eco",
  ECOV: "Eco V",
  HORS_GEL: "No Frost",
  TEMPERATURE: "Temperature",
  ARRET: "Stop",
  UNKNOWN: "Unknown",
  ERROR: "Error",
};

const myvType: Record<SiteAutodiagDeviceProgrammingType, string> = {
  DEFAULT: "Default",
  USER: "User",
  QUICK: "Quick",
  MANUAL: "Manual",
  UNKNOWN: "Unknown",
  ERROR: "Error",
};

export const SITE_AUTODIAG_TABLE_ENGLISH_LOCALE = {
  empty: "No Devices",
  syncMyVProgrammingButton: "Synchronize MyV programming",
  headers: {
    name: "Device name",
    result: "Result",
    start: "Start Date",
    end: "End Date",
    energyManager: "Energy manager",
    programmingMode: "MyV Mode",
    programmingType: "MyV Mode Type",
    programmingState: "Synchronisation",
    help: "Hint",
    actions: "Actions",
    launchDiag: "Launch diag",
  },
  test,
  energyManager,
  conformity,
  myvMode,
  myvType,
  sensorPopover: {
    serial: "Serial number",
    hwId: "Hw ID",
    csId: "Cs ID",
    installationDate: "Installation date",
  },
} satisfies typeof SITE_AUTODIAG_TABLE_FRENCH_LOCALE;
